module.exports = __webpack_public_path__ + "static/img/damaged.1db7e2dd.png";